// web_common_upload_uploadAttachment 上传附件

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 接口地址：

export default function web_common_upload_uploadAttachment(pParameter) {
  if (!pParameter) pParameter = {};
  const formData = new FormData();
  formData.append('fileUpload', pParameter);
  return __request({
    urlSuffix: '/web/common/upload/uploadAttachment',
    data: formData,
    // process_response_data: false,
    transformRequest: [function (data, headers) {
      return data;
    }],
  });
}
